import { Tab, Tabs } from '@readcloud/component-library';
import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import SwipeableViews from 'react-swipeable-views';
import * as yup from 'yup';
import { Forms } from '../..';
import { ColorPicker } from '../Drawings';
import { SliderInput } from '../Drawings/SliderInput';
import { rgbToString } from '../Drawings/utils';
import {
  AnnotationEditorFormProps,
  makeAnnotationEditor,
} from '../makeAnnotationEditor';

const schema = yup
  .object({
    fill: yup.string().required(),
    stroke: yup.string().required(),
    strokeWidth: yup.number().required(),
    rect: yup
      .object({
        x: yup.number(),
        y: yup.number(),
        width: yup.number(),
        height: yup.number(),
      })
      .required(),
  })
  .shape(Forms.commonSchemas.commonFields);

function ShapeAnnotationEditorForm<FormValues extends object>(
  props: AnnotationEditorFormProps & { disableStroke: boolean }
) {
  const form = useForm();
  const formState = useFormState();
  const [tab, setTab] = React.useState<'fill' | 'stroke'>('fill');

  const handleTabChange = React.useCallback((v: any) => {
    setTab(v);
  }, []);

  return (
    <div className="rc-flex rc-flex-col">
      <Tabs
        className="rc-w-full"
        defaultActiveKey={tab}
        onSelect={handleTabChange}
      >
        {[
          <Tab
            key="fill"
            tabClassName={'annotation-tab'}
            eventKey="fill"
            title="Fill"
          />,
          ...(props.disableStroke
            ? []
            : [
                <Tab
                  key="stroke"
                  tabClassName={'annotation-tab'}
                  eventKey="stroke"
                  title="Stroke"
                />,
              ]),
        ]}
      </Tabs>
      <div className="rc-p-2" />
      <SwipeableViews animateHeight disabled index={tab === 'fill' ? 0 : 1}>
        <div>
          <ColorPicker
            className="rc-overflow-hidden"
            color={formState.values.fill}
            onChange={(change) => form.change('fill', rgbToString(change.rgb))}
          />
        </div>
        <div>
          {!props.disableStroke && (
            <ColorPicker
              color={formState.values.stroke || '#000000'}
              onChange={(change) =>
                form.change('stroke', rgbToString(change.rgb))
              }
            >
              <div className="rc-py-1"></div>
              <SliderInput
                label="Thickness"
                value={formState.values.strokeWidth || 0}
                onChange={(value) => form.change('strokeWidth', value)}
                min={1}
                max={20}
                step={1}
              />
            </ColorPicker>
          )}
        </div>
      </SwipeableViews>
      <div className="rc-py-2"></div>
      <div className="rc-flex rc-flex-col">
        <Forms.commonElements.CommonFields
          showPublisherOptions={props.showPublisherOptions}
          showDescription
        />
      </div>
    </div>
  );
}
export const ShapeAnnotationEditor = React.memo(
  makeAnnotationEditor({
    FormComponent: ShapeAnnotationEditorForm,
    // @ts-expect-error: This error goes away once "strictNullChecks" are set to true
    schema,
  })
);
